import { useEffect, useState, useRef } from "react";
import { ChangeAlertCallbackType } from '../../../Root';
import { useAFBFunction } from '../../../customwidgets/afb-company-admin/hooks/useAFBFunction';
import { SpaceService } from "../../../../services/SpaceService";
import { afbRecurringFrecuency } from "../../../../util/DataObject";
import { useDialog } from "@albo-ui/core";

export const useOperationManager = (open: boolean, onClose: Function, changeAlert: ChangeAlertCallbackType, onHandleExecute: Function, data: any) => {
    const { handleSpacesGet, handleCatalog } = useAFBFunction(changeAlert);
    const dialogProps = useDialog();
    const spaceService = useRef<SpaceService>();

    const [zPos, setZPos] = useState(45);
    const [form, setForm] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isValid, setIsValid] = useState<boolean>(true);

    const [element, setElement] = useState(null);
    const [dialogText, setDialogText] = useState({});
    const [item, setItem] = useState(null);

    const [searchForm, setSearchForm] = useState(null);
    const [spaces, setSpaces] = useState([]);
    const [email, setEmail] = useState("");
    const [catalogBank, setCatalogBank] = useState(null);

	const agent = localStorage.session ? JSON.parse(localStorage.session) : {};

    const onHandleSearch = (e) => {
        setSearchForm({customer_uuid: e["target"]["value"].trim()});
    };

    const onHandleChange = (key1, key2, e) => {
        let f = form ? form : {};
        let er = error;
        
        let value = e && e["target"] ? e["target"]["value"] : String(e) ? e : e["props"]["value"];

        if (key2 && key1) {
            f[key1] ? f[key1][key2] = value : f[key1] = {...form[key1], [key2]: value}
            if (key2 === "type") {
                f[key1]["value"] = 0;
            }
        } else if(key1 === "notification_emails"){
            if (f[key1] && f[key1].length > 0) {
                f["notification_emails"].indexOf(value) < 1 && f[key1].push(value);
            } else {
                f[key1] = [value];
            }
        } else if(key1.includes("date")){
            const iso = key1 === "start_date"
                ? `${value.slice(0,14)}00:00.000Z`
                : `${value}:59.999Z`;
            f[key1] = iso;
        } else if(key1){
            f[key1] = value;
        }

        if (!value){
            key2 && key1 && (er = "Campo obligatorio");
        } else {
            key2 && key1 && (er = "");
        }

        setForm(JSON.parse(JSON.stringify(f)));
        setError(JSON.parse(JSON.stringify(er)));
        validateForm(f, er);
    };

    const validateForm = (f, e) => {
        const allFieldsFilled = 
        Object.values(["frecuency", "target_receipt", "amount_config", "start_date", "end_date" ]).every((field) => {
            if (typeof field === 'object') {
                return Object.values(field).every((value) => String(value).trim() !== '');
            }
            return String(field).trim() !== '';
        }) && 
        Object.values(f).filter(value => typeof value === 'string').every(value => String(value).trim() !== '');
        
        setIsValid(!allFieldsFilled);
    };

    const formatDateForInput = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        const iso = date.toISOString();
        return iso.slice(0, 16);
    };

    const onHandleDelete = async (email) => {
        let f = form;
        let newList = form["notification_emails"].filter(i => i !== email);
        f["notification_emails"] = newList;
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onOpenConfirm = () => {
        let f = form;

        f["start_date"] = f.start_date.replace("Z", "-06:00");
        f["end_date"] = f.end_date.replace("Z", "-06:00");

        let payload = {
            uuid: f.uuid, 
            status: f.status,
            start_date: f.start_date,
            end_date: f.end_date,
            updated_by: agent['email']
        };
        f["notification_emails"] && (payload["notification_emails"] = f["notification_emails"]);
        // f["metadata"] && (payload["metadata"] = f["metadata"]);
        if (!data) {
            payload = f;
            payload["created_by"] = agent["email"];
            payload["admin_uuid"] = agent["uuid"];
            payload["operation_type"] = "transferIndividual";
            payload["amount_config"]["value"] = Number(payload["amount_config"]["value"]) || 0;
        }
        setItem(JSON.parse(JSON.stringify(payload)));
        setDialogText({
            title: "Confirmar Operación",
            message: "¿Estás seguro que deseas generar la Operación Recurrente?",
            confirmButton: "Confirmar"
        });
        let dataToDisplay = [
            { key: "customer_name", name: "Empresa", label: payload["metadata"]["customer_name"] },
            { key: "frecuency", name: "Frecuencia", label: afbRecurringFrecuency.filter(i => i.key === payload["frecuency"])[0]["label"]},
        ];

        setElement([
            { key: "items", type: "items", items: dataToDisplay, text: `Datos de la Operación` }
        ]);

        dialogProps.openDialog();
    };

    const onConfirm = async () => {
        setLoading(true);
        setZPos(-1);

        await onHandleExecute({data: item});

        setZPos(45);
        setLoading(false);
    };

    const onSearch = async () => {
        setLoading(true);
        setZPos(-1);

        let resp = await handleSpacesGet(searchForm["customer_uuid"], true);

        if (resp) {
            let newForm = {
                source_customer_uuid: searchForm["customer_uuid"],
                metadata: { customer_name: resp[0]["data"]["content"][0]["name"] }
            };
            setForm(JSON.parse(JSON.stringify(newForm)));
            setSpaces(JSON.parse(JSON.stringify(resp[1]["data"]["content"])));

            resp.length === 0 && changeAlert(true, "error", "No se encontraron Spaces asociados al cliente.");
            setLoading(false);
        } else {
            setLoading(false);
        }

        setLoading(false);
        setZPos(45);
    };

    const getCatalog = async (type: string) => {
        setLoading(true);
        setZPos(-1);

        let resp = await handleCatalog(type);
        if(resp){
            setCatalogBank(resp);
        }

        setLoading(false);
        setZPos(45);
    };

    const onHandleConfirm = () => {
        dialogProps.onClose();
        onConfirm();
    };
    const onCloseDialogConfirm = () => {
        dialogProps.onClose();
        resetFields();
    };
    const resetFields = () => {
        setElement(null);
        setDialogText({});
        setItem(null);
    };

    useEffect(() => {
        spaceService.current = new SpaceService(changeAlert)
        
        if (!open) {
            setForm(null);
            setError(null);
            setIsValid(true);
            setSearchForm(null);
            setSpaces([]);
            setEmail("");
            setCatalogBank(null);
        } else {
            getCatalog("banks");
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        zPos,
        form,
        error,
        email,
        spaces,
        loading,
        isValid,
        searchForm,
        catalogBank,
        item, element, dialogText, dialogProps,
        setForm,
        onHandleChange,
        onHandleSearch,
        onSearch,
        setEmail,
        onConfirm,
        onHandleDelete,
        formatDateForInput,
        onHandleConfirm, onCloseDialogConfirm, onOpenConfirm
    };
};
